// extracted by mini-css-extract-plugin
module.exports = {"title":"GreenTitle-module--title--3nhbQ","caps":"GreenTitle-module--caps--3Nbe9"};